import { dataSpeedGensSchema } from "./schema";
import { getEntities, getEntityIds } from "./base";

const path = "/portal/api/data_speed_gens";

const getDataSpeedGenIds = (clientConfig, offerType, dataStatus) => {
  return getEntityIds(
    clientConfig,
    dataStatus,
    path,
    offerType,
    clientConfig.limits
  );
};

const getDataSpeedGens = (clientConfig, dataStatus) => {
  let limits = { ...clientConfig.limits };
  limits.brandId = [];
  limits.phoneId = [];
  limits.phoneOperatingSystemId = [];
  limits.phoneVariantId = [];

  return getEntities(
    clientConfig,
    dataStatus,
    path,
    dataSpeedGensSchema,
    {},
    limits
  );
};

export { getDataSpeedGenIds, getDataSpeedGens };
